module.exports = __webpack_public_path__ + "media/images/steak-7e54ac787a7bda36b84752578aeec3b7.png";